import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Btnsearch from '../../atoms/btnsearch';
import { fireStore } from '../../../database/utils/firebase';
import * as S from './styles';

import Header from '../../molecules/Header';
import MainContent from '../../molecules/MainContent';
import Footer from '../../molecules/Footer';
import { useSearchPath } from '../../../hooks/useSeachPath';
import UserAdmin from '../../organisms/UserAdmin';

function AdminClient() {
  const [search, setSearch] = useState('');
  const searchPath = useSearchPath(search);

  const [userList, setUserList] = useState([]);
  useEffect(() => {
    fireStore
      .collection('usuarios')
      .get()
      .then((response) => {
        const tempUserList = [];
        response.docs.map((doc) =>
          tempUserList.push({
            id: doc.id,
            ...doc.data()
          })
        );
        setUserList(tempUserList);
      });
  }, []);

  return (
    <S.Container>
      <Header />
      <MainContent>
        <S.Content>
          <form>
            <input
              type="text"
              value={search}
              placeholder="Estou procurando por..."
              onChange={(e) => setSearch(e.target.value)}
            />
            <Link to={searchPath}>
              <Btnsearch type="submit" title="Encontrar" href={searchPath} />
            </Link>
          </form>
        </S.Content>
        <div className="table-title-container">
          <h1>Usuários</h1>
        </div>
        <S.TableContainer>
          {userList.map((user) => (
            <UserAdmin key={user.id} user={user} />
          ))}
        </S.TableContainer>
      </MainContent>
      <Footer />
    </S.Container>
  );
}

export default AdminClient;
